import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const NotificationInboxPage = lazy(
  () => import('~/features/notifications/pages/notification-inbox-page'),
);

export const Route = createFileRoute('/_authenticated/_tenant/notification')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <NotificationInboxPage />
    </Suspense>
  ),
});
